import api from "../api/axiosInterceptor";

const BASE_URL = process.env.REACT_APP_CONFIG_API;

export const getDatabaseConfig = async () => {
    const response = await fetch(`${BASE_URL}/config/get`);
    return response.json();
};

export const saveDatabaseConfig = async (data) => {
    return api.post(`${BASE_URL}/config/update`, data);
};

export const addDatabaseConnection = async (payload) => {
    const data = await api.post(`${BASE_URL}/config/add-connection`, payload);
    console.log("Connection added", data.data);
    return data;
};

export async function deleteDatabaseConnection(payload) {
    const data = await api.post(`${BASE_URL}/config/delete-connection`, payload);
    return data;
}

export async function updateDatabaseConnection(payload) {
    const data = await api.post(`${BASE_URL}/config/update-connection`, payload);
    return data;
}

export async function setActiveInstance(INSTANCE) {
    return api.post(`${BASE_URL}/config/set-active-instance`, { INSTANCE });
}

// ✅ ADD THIS - Test instance connection
export async function testInstanceConnection(instance) {
    try {
        const response = await api.post(`${BASE_URL}/api/test-instance`, { instance });
        // Axios interceptor already returns response.data, so response is already the data
        return response;
    } catch (error) {
        console.error("Connection test error:", error);
        throw error;
    }
}

// Test database connection with provided credentials
export async function testDatabaseConnection(connectionDetails) {
    try {
        // Validate BASE_URL is set
        if (!BASE_URL) {
            console.error("BASE_URL is not set. Check REACT_APP_CONFIG_API environment variable.");
            return { 
                success: false, 
                message: "Configuration error: API base URL is not set. Please check your environment variables." 
            };
        }

        console.log("Testing connection with:", { 
            DB_HOST: connectionDetails.DB_HOST, 
            DB_PORT: connectionDetails.DB_PORT, 
            DB_NAME: connectionDetails.DB_NAME,
            DB_USERNAME: connectionDetails.DB_USERNAME,
            // Don't log password
        });
        console.log("API URL:", `${BASE_URL}/config/test-connection`);
        
        // Axios interceptor already returns response.data, so response is already the data object
        const response = await api.post(`${BASE_URL}/config/test-connection`, connectionDetails);
        console.log("Test connection response:", response);
        
        // Ensure we have a valid response
        if (!response) {
            console.error("No response received from server");
            return { success: false, message: "No response from server" };
        }
        
        return response;
    } catch (error) {
        console.error("Connection test error:", error);
        console.error("Error details:", {
            message: error.message,
            response: error.response,
            responseData: error.response?.data,
            status: error.response?.status,
        });
        
        // Return error response if available
        if (error.response?.data) {
            return error.response.data;
        }
        
        // Handle network errors or other issues
        if (error.message) {
            return {
                success: false,
                message: error.message
            };
        }
        
        // Return a proper error structure if no response data
        return {
            success: false,
            message: "Failed to test connection. Please check your network connection and server status."
        };
    }
}